import React from 'react';
import { Clock, ShieldCheck, LayoutDashboard } from 'lucide-react';
import { Reveal } from './Reveal';

const CARDS = [
  {
    icon: Clock,
    title: 'Calm',
    body: 'It answers one question first — is this worth my time? — then reveals depth on demand. Density is earned, never front-loaded.',
    em: 'is this worth my time?',
  },
  {
    icon: ShieldCheck,
    title: 'Accountable',
    body: 'Every score, recommendation, and proposal claim carries its evidence on its sleeve. You can trace anything back to the source.',
  },
  {
    icon: LayoutDashboard,
    title: 'Role-aware',
    body: 'The interface reshapes around your stage — discovering, qualifying, writing — instead of forcing one dashboard to do everything.',
  },
];

/** Section 01 — the product thesis + three principles. */
export function WhyBidWin() {
  return (
    <section className="max-w-[1180px] mx-auto px-5 sm:px-8 pt-24 pb-6">
      <Reveal className="max-w-[680px] mb-[54px]">
        <div className="font-mono text-[11px] font-semibold tracking-[0.14em] text-bw-accent mb-4">
          01 — WHY BIDWIN
        </div>
        <h2 className="text-[clamp(30px,3.6vw,46px)] leading-[1.08] font-extrabold tracking-[-0.03em] text-bw-sidebar mb-[18px]">
          Most tools bury you in listings or hand you confident lies.
        </h2>
        <p className="text-lg leading-[1.6] text-fit-weak">
          301 undifferentiated opportunities, or a polished proposal full of claims you can’t back.
          BidWin is built on one discipline:{' '}
          <span className="text-bw-ink font-semibold">
            if it isn’t in your profile, it doesn’t exist in your proposal.
          </span>
        </p>
      </Reveal>

      <Reveal>
        <div className="flex flex-wrap gap-6">
          {CARDS.map(({ icon: Icon, title, body, em }) => (
            <div
              key={title}
              className="flex-1 basis-[300px] min-w-[260px] bg-bw-surface border border-bw-border rounded-[14px] p-7 shadow-card"
            >
              <div className="w-[42px] h-[42px] rounded-[11px] bg-bw-primary-tint flex items-center justify-center mb-[18px]">
                <Icon className="w-[21px] h-[21px] text-bw-primary" strokeWidth={2} />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 text-bw-ink">{title}</h3>
              <p className="text-[15px] leading-[1.55] text-bw-muted">
                {em ? (
                  <>
                    {body.split(em)[0]}
                    <em>{em}</em>
                    {body.split(em)[1]}
                  </>
                ) : (
                  body
                )}
              </p>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
